import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SettingsModal.css';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SettingsModal: React.FC<SettingsModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSignout = () => {
    // Clear all items from localStorage
    localStorage.clear();

    // Close the modal
    onClose();

    // Redirect to the signin page
    navigate('/signin');
  };

  return (
    <div className="settings-modal-overlay" onClick={onClose}>
      <div className="settings-modal" onClick={e => e.stopPropagation()}>
        <div className="settings-modal-header">
          <h2>Setting</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="settings-modal-content">
          <button className="settings-option">Help</button>
          <button className="settings-option">Sample policy</button>
          <button className="settings-option">Payout policy</button>
          <button className="settings-option">Setting and privacy</button>
          <button className="settings-option signout" onClick={handleSignout}>Signout</button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
